import React from 'react'
import './EndPage.css'

const EndPageModal = () => {
  return (
    <div className='content'>
    <div className="wrapper-1">
      <div className="wrapper-2">
        <h1>Thank you !</h1>
        <p>Thank you for volunteering to be a LTE teacher. </p>
        <p>We will send you an email confirmation shortly. </p>
        {/* <button className="go-home">
        go home
        </button> */}
      </div>
      
  </div>
  <p className="product">
      Designed & Powered by <a href="https://blackwinstech.com/"     rel="noreferrer"
 target="_blank"> Blackwins Tech Solutions</a> 
        </p>
  </div>
  
  )
}

export default EndPageModal